// @flow
import { handleResponseOld, makeGet } from './helpers';

type FetchUserVariantsBySessionIdParams = {
    authToken: string,
    deployment: string,
    userSessionId: string,
};

export const fetchUserVariantsBySessionId = ({
    authToken,
    deployment,
    userSessionId,
}: FetchUserVariantsBySessionIdParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makeGet({ authToken, deployment, path: '<VARIANT-TEST-API>gettestvariants' });
        request.send({ userSessionId });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });
